import PathConstants from '@/main/routes/path-contants'
import theme from '@/presentation/assets/styles/theme'
import { ValidAccountState } from '@/presentation/contexts/auth'
import useAccount from '@/presentation/hooks/auth/use-account'
import logoIconUnicoSkill from '@images/logo-icon-unico-skill.svg'
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'
import { AppBar, Box, Container, IconButton, Toolbar } from '@mui/material'
import { Link } from 'react-router-dom'
import MobileUserMenu from './mobile-user-menu'
import MobileSearchMenu from './mobile-search-menu'
import SxHeader from '../../sx-header'
import { Analytics } from '../../analytics'

type MobileHeaderProps = {
  enableSearch: boolean
  trigger: boolean
  openDialogMenu: boolean
  openDialogSearchMenu: boolean
  setOpenDialogMenu: (open: boolean) => void
  setOpenDialogSearchMenu: (open: boolean) => void
  handleOpenMenu: (event: React.MouseEvent<HTMLElement>) => void
  handleCloseMenu: () => void
}

// Mobile Header Component
export default function MobileHeader({
  enableSearch,
  trigger,
  openDialogMenu,
  openDialogSearchMenu,
  setOpenDialogMenu,
  setOpenDialogSearchMenu,
  handleOpenMenu,
  handleCloseMenu
}: MobileHeaderProps) {
  const [account] = useAccount() as ValidAccountState
  const { HOME } = PathConstants.Routes

  const handleClickOnLogo = () => {
    Analytics.trackNavigate(HOME.name)
  }

  return (
    <Box className="only-mobile">
      <AppBar component="nav" sx={SxHeader.appBar(trigger, true)} position="fixed">
        <Toolbar
          sx={{
            height: theme.spacing(8),
            bgcolor: theme.palette.common.white
          }}
          className="border-0 border-b border-solid border-[color:var(--grey-50)]"
        >
          <Container
            disableGutters
            maxWidth="lg"
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '16px'
            }}
          >
            <Box
              sx={{
                flexGrow: 1,
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Box
                component={Link}
                to={HOME.value}
                sx={{
                  height: theme.spacing(5),
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <img
                  src={logoIconUnicoSkill}
                  alt="Unico Skill"
                  className="cursor-pointer"
                  onClick={handleClickOnLogo}
                />
                <img
                  src={`${account.company.logoUrl}`}
                  alt={account.company.name}
                  className="h-[70%] ml-2 cursor-pointer"
                  onClick={handleClickOnLogo}
                />
              </Box>
            </Box>

            <Box className="flex items-center justify-end">
              {enableSearch && (
                <IconButton
                  size="small"
                  sx={{ ml: 3 / 2 }}
                  aria-haspopup="true"
                  onClick={() => setOpenDialogSearchMenu(true)}
                >
                  <SearchOutlinedIcon sx={{ color: theme.palette.grey[900] }} />
                </IconButton>
              )}

              <IconButton sx={{ ml: 1 / 2 }} onClick={handleOpenMenu}>
                <MenuOutlinedIcon sx={{ color: theme.palette.grey[900] }} />
              </IconButton>

              <MobileUserMenu
                open={openDialogMenu}
                setOpen={setOpenDialogMenu}
                handleClose={handleCloseMenu}
              />

              <MobileSearchMenu
                open={openDialogSearchMenu}
                handleClose={() => setOpenDialogSearchMenu(false)}
              />
            </Box>
          </Container>
        </Toolbar>
      </AppBar>
    </Box>
  )
}
